export const view = {
  receipt: {
    create: 'Agregar Recibo',
    edit: 'Editar Recibo',
    delete: 'Eliminar Ajuste',
    enRoute: 'En Ruta',
    receipts: 'Recibos',
  },
};
